<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortBoxEvents($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- User Column -->
      <ng-container matColumnDef="user">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>User</th>
        <td *matCellDef="let element" mat-cell> {{element.appliant}} </td>
      </ng-container>


      <!-- Date Column -->
      <ng-container matColumnDef="timestamp">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Date</th>
        <td *matCellDef="let element" mat-cell> {{element.timestamp | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <!-- Contract Id Column -->
      <ng-container matColumnDef="contractId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Contract Id</th>
        <td *matCellDef="let element" mat-cell> {{element.contractId}} </td>
      </ng-container>

      <!-- Event Type Column -->
      <ng-container matColumnDef="eventsType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Event Type</th>
        <td *matCellDef="let element" mat-cell> {{element.eventsType | splitCamelCase}} </td>
      </ng-container>


      <!-- Event Details Column -->
      <ng-container matColumnDef="details">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Event Details</th>
        <td *matCellDef="let element" mat-cell> {{element.details}} </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No history found for this box
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorBoxEvents [fxShow]="dataSource && dataSource.data.length > 10"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>